import React from 'react';
import CopyToClipboard from 'react-copy-to-clipboard';
import { ignoredKeys } from '../../consts/trans';
import { beautify, maskString, amount } from '../../helpers/str';
import { transform } from '../../helpers/transform';
import Svg from '../atoms/Svg';

const Collapsible = ({
    title,
    data,
    transformMap,
    mask = false,
    maskFields = [],
    collapsed = true,
    showFieldCount = true,
    copied,
    setCopied,
    uniqueId,
    children,
}) => {
    const filteredKeys = Object.keys(data || {}).filter((k) => ignoredKeys.indexOf(k) === -1);
    const fieldCount = filteredKeys.length;

    return (
        <div className=''>
            <div className='card card-flush rounded-0 shadow-none border-top-0'>
                <div
                    className={`card-header collapsible cursor-pointer rotate ${
                        collapsed ? 'collapsed' : ''
                    }`}
                    aria-expanded={!collapsed}
                    data-bs-toggle='collapse'
                    data-bs-target={`#${uniqueId}`}>
                    <div className='d-flex w-100 justify-content-between mt-2'>
                        <div>
                            <h4 className='card-title mb-1'>{title}</h4>
                            {showFieldCount && (
                                <p className='text-gray-500 card-summary fs-7'>
                                    {fieldCount} fields
                                </p>
                            )}
                        </div>
                        <div className='card-toolbar'>
                            <span className='svg-icon svg-icon-1'>
                                <Svg
                                    icon='down'
                                    className='svg-icon-2'
                                />
                            </span>
                        </div>
                    </div>
                </div>
                <div
                    id={uniqueId}
                    className={`collapse ${collapsed ? 'hide' : 'show'}`}>
                    <div className='card-body p-0'>
                        {children ? (
                            children
                        ) : (
                            <table className='table align-middle table-striped gy-3 gs-5 m-0'>
                                <tbody>
                                    {Object.entries(data || {}).map(([childKey, childValue]) => {
                                        let processedValue = childValue;

                                        if (transformMap?.[childKey]) {
                                            processedValue = transform(
                                                transformMap[childKey],
                                                processedValue
                                            );
                                        } else if (typeof processedValue === 'boolean') {
                                            processedValue = processedValue ? 'Yes' : 'No';
                                        } else if (childKey.includes('amount')) {
                                            processedValue = amount(processedValue);
                                        }

                                        if (mask && maskFields.indexOf(childKey) !== -1) {
                                            processedValue = maskString(processedValue);
                                        }

                                        return ignoredKeys.indexOf(childKey) === -1 ? (
                                            <tr key={childKey}>
                                                <td className='fw-bold text-gray-700 w-40'>
                                                    {beautify(childKey)}
                                                </td>
                                                <td className='text-gray-800'>
                                                    {(childKey.indexOf('_id') !== -1 ||
                                                        childKey === 'id') && (
                                                        <CopyToClipboard
                                                            text={processedValue}
                                                            onCopy={() =>
                                                                setCopied(`${uniqueId}_${childKey}`)
                                                            }>
                                                            <span
                                                                role='button'
                                                                className='me-2'>
                                                                <Svg
                                                                    icon='copy'
                                                                    className={`svg-icon-4 text-${
                                                                        copied &&
                                                                        copied ===
                                                                            `${uniqueId}_${childKey}`
                                                                            ? 'success'
                                                                            : 'warning'
                                                                    }`}
                                                                />
                                                                {copied &&
                                                                    copied ===
                                                                        `${uniqueId}_${childKey}` && (
                                                                        <small className='text-success me-1'>
                                                                            Copied!
                                                                        </small>
                                                                    )}
                                                            </span>
                                                        </CopyToClipboard>
                                                    )}
                                                    {processedValue}
                                                </td>
                                            </tr>
                                        ) : (
                                            <React.Fragment key={childKey}></React.Fragment>
                                        );
                                    })}
                                </tbody>
                            </table>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Collapsible;
